import $ from "jquery";
// import clickOutside from 'click-outside';

/*------------------------------------*\
    PAGE NAV
\*------------------------------------*/
class PageNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.nav = self.elem.querySelector('[data-page-nav]');
        self.dropdown = self.elem.querySelector('[data-page-nav-dropdown]');
        self.item = self.elem.querySelector('[data-page-nav-item]');
        self.trigger = self.elem.querySelector('[data-page-nav-trigger]');
    }

    init() {
        let self = this;

        self.stickyNav();
    }

    stickyNav() {
        let self = this;

        document.addEventListener('scroll', (e) => {
            if (window.scrollY > self.trigger.offsetTop) {
                self.item.classList.add('is-sticky');
            } else {
                self.item.classList.remove('is-sticky');
            }
        });
    }
}

export default PageNav;
